/**
 * @file    useDrawerStore.ts
 * @scope   SHARED
 * @summary Global-store fields the drawer reads, one selector per field.
 * @consumes Global store (`useStore`)
 * @produces UseDrawerStoreResult
 * @sideEffects None.
 * @notes WHY one selector per field: a single selector returning an object rebuilt a new reference
 *        on every store mutation, so any unrelated store change re-rendered the whole drawer.
 */
import { useStore } from 'store/useGlobalStore';

export const useDrawerStore = () => ({
  customWidget: useStore((state) => state.customWidget),
  widgets: useStore((state) => state.widgets),
  widgetsList: useStore((state) => state.widgetsList),
  endpoints: useStore((state) => state.endpoints),
  isConsumer: useStore((state) => state.isConsumer),
  setState: useStore((state) => state.setState),
  selectedDiyChildChart: useStore((state) => state.selectedDiyChildChart),
  dataSourceType: useStore((state) => state.dataSourceType),
  dashboardView: useStore((state) => state.dashboardView),
  workspace: useStore((state) => state.configDashboard.workspace),
  useDiyHierarchyFilters: useStore((state) => state.configDashboard.useDiyHierarchyFilters),
  useAdvancedFilters: useStore((state) => state.configDashboard.useAdvancedFilters),
  savedEnterpriseWidgetId: useStore((state) => state.savedEnterpriseWidgetId),
});

export type UseDrawerStoreResult = ReturnType<typeof useDrawerStore>;
